import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function CheckLightIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Stroke 3"
        d="M8.08594 11.5007L10.361 13.7748L14.9093 9.22656"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
